export let TabsIndicatorCssVars = /*#__PURE__*/function (TabsIndicatorCssVars) {
  TabsIndicatorCssVars["activeTabLeft"] = "--active-tab-left";
  TabsIndicatorCssVars["activeTabRight"] = "--active-tab-right";
  TabsIndicatorCssVars["activeTabTop"] = "--active-tab-top";
  TabsIndicatorCssVars["activeTabBottom"] = "--active-tab-bottom";
  TabsIndicatorCssVars["activeTabWidth"] = "--active-tab-width";
  TabsIndicatorCssVars["activeTabHeight"] = "--active-tab-height";
  return TabsIndicatorCssVars;
}({});